module.exports = __webpack_public_path__ + "img/Monte_Kope_54.25bde21f.jpg";